// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#settings[data-v-acbb73ba]{margin-top:4rem}.preserve[data-v-acbb73ba]{white-space:pre-line}.reset[data-v-acbb73ba]{margin-left:1rem}.searchs .tag[data-v-acbb73ba]{margin-right:.5rem;min-width:50px;border:1px solid #666;cursor:pointer;padding:.5rem;color:#333}.unselected-text[data-v-acbb73ba]{color:transparent}", ""]);
// Exports
module.exports = exports;
